import { render, staticRenderFns } from "./ComboCheckItems.vue?vue&type=template&id=6f4f5b1b"
import script from "./ComboCheckItems.vue?vue&type=script&lang=js"
export * from "./ComboCheckItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports